import React, { lazy, Suspense, useContext, useEffect, useState } from "react";
import HelmetContainer from "../../components/elements/helmetContainer/HelmetContainer";
import HomePageHeader from "../../components/home/headers/HomePageHeader";
import HomePageAboutProject from "../../components/home/aboutProject/HomePageAboutProject";
import HomePageBenefits from "../../components/home/benefits/HomePageBenefits";
import HomePageStillHaveQuestions from "../../components/home/stillHaveQuestions/HomePageStillHaveQuestions";
import HomePageContact from "../../components/home/contact/HomePageContact";
import Footer from "../../components/elements/footer/Footer";
import Header from "../../components/header/Header";
import { AuthContext } from "../../App";
import { useLocation } from "react-router-dom";
import axios from "axios";
import userAuthenticationConfig from "../../utils/userAuthenticationConfig";
import { responseStatus, standardErrorsWay } from "../../utils/consts";
import HomePagePriceCalculator from "../../components/home/priceCalculator/HomePagePriceCalculator";
import HomePageHowItWork from "../../components/home/howItWork/HomePageHowItWork";
import HomePageAboutUs from "../../components/home/aboutUs/HomePageAboutUs";
import {
  StyledHiddenWrapper,
  StyledHomePageContainer,
  StyledHomePageSectionBlock,
  StyledHomePageWrapper
} from "../../components/home/styledHomePage";
import { parseAxiosError } from "../../utils/response";
import ScrollToTop from "../../components/elements/scrollBtn/ScrollBtn";

const HomePageLook = lazy(() => import("../../components/home/lookScriptChat/HomePageLook"));
const HomePageReviews = lazy(() => import("../../components/home/reviews/HomePageReviews"));

const HomePage = () => {

  const [offset, setOffset] = useState(true);

  const { user } = useContext(AuthContext);

  const [userInfo, setUserInfo] = useState(null);
  const location = useLocation();

  const fetchUser = () => {

    if (user && location.pathname === "/") {
      axios.get("/api/users/" + user?.userId, userAuthenticationConfig()).then(response => {
        if (response.status === responseStatus.HTTP_OK) {
          setUserInfo(response.data);
        }
      }).catch(error => {
        parseAxiosError(eval(standardErrorsWay));
      });
    }
  };

  useEffect(() => {
    const onScroll = () => {
      if (window.pageYOffset < 350) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    const scrollTopBeforeUnload = () => {
      window.scrollTo(0, 0);
    };

    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });

    window.addEventListener("beforeunload", scrollTopBeforeUnload);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("beforeunload", scrollTopBeforeUnload);
    };
  }, []);

  return (
    <HelmetContainer
      title="Add Online Chat for Your Website - Online Chat Widget Text me"
      description="Text-me - simple customer support software 🔷 Create custom chat widget for your website in a few minutes 🔷 Try a quick trial version Text me for free 📲 💻 Integration with popular chats and messengers ➤ Telegram ➤ Viber ➤ WhatsApp"
      page="Home"
    >
      <ScrollToTop />
      <StyledHomePageWrapper>
        <div className="before-block" />
        <Header
          userInfo={userInfo}
          inViewport={offset}
        />
        <StyledHiddenWrapper>
          <StyledHomePageContainer>
            <HomePageHeader
              userInfo={userInfo}
              fetchUser={fetchUser}
              inViewport={offset}
            />
            <HomePageAboutProject />
          </StyledHomePageContainer>
          <StyledHomePageSectionBlock id="section">
            <HomePageBenefits />
          </StyledHomePageSectionBlock>
          <Suspense fallback={<div></div>}>
            <HomePageLook />
          </Suspense>
          <HomePagePriceCalculator />
          <HomePageHowItWork />
          <HomePageAboutUs />
          <Suspense fallback={<div></div>}>
            <HomePageReviews />
          </Suspense>
          <HomePageStillHaveQuestions />
          <HomePageContact />
        </StyledHiddenWrapper>
      </StyledHomePageWrapper>
      <Footer />
    </HelmetContainer>
  );
};

export default HomePage;